/*
 * @Descripttion: 
 * @Author: heng.wu
 * @Date: 2022-8-9 14:26:29
 * @LastEditors: zhongbin.chen
 * @LastEditTime: 2022-8-9 14:26:21
 */
import { RootObject } from '@/model/rootObject'
import https from '@/utils/https'
import { RequestParams, ContentType, Method } from 'axios-mapper'

// 楼宇列表查询
export const buildingListRequest = (params:any) => {
  return https().request('building', Method.GET, params, ContentType.json)
}

// 楼宇添加
export const buildingAdd = (params:any) => {
  return https().request('building', Method.POST, params, ContentType.json)
}

// 楼宇更新
export const buildingPut = (params:any,buildingId:any) => {
  return https().request(`building?id=${buildingId}`, Method.PUT, params, ContentType.json)
}

// 楼宇删除
export const buildingDelete = (params:any) => {
  return https().request('building', Method.DELETE, params, ContentType.form)
}

// 楼层列表查询
export const buildingFloorRequest = (params:any) => {
  return https().request('building/floor', Method.GET, params, ContentType.form)
}

// 楼层添加
export const buildingFloorAdd = (params:any,rommid:any) => {
  return https().request(`building/floor?building_id=${rommid}`, Method.POST, params, ContentType.json)
}

// 楼层删除
export const buildingFloorDelete = (params:any) => {
  return https().request('building/floor', Method.DELETE, params, ContentType.form)
}

// 楼层更新
export const buildingFloorPut = (params:any,buildingId:any,floorId:any) => {
  return https().request(`building/floor?building_id=${buildingId}&id=${floorId}`, Method.PUT, params, ContentType.json)
}

// 获取关联机器人的列表
// export const buildingRobots = (params:any) => {
//   return https().request(`building/robots`, Method.GET, params, ContentType.form)
// }

// 获取关联机器人的列表
export const buildingRobots = (params:any) => {
  return https().request(`robots`, Method.GET, params, ContentType.form)
}
// 
export const buildingRobotsAll = (params:any) => {
  return https().request(`robots/all`, Method.GET, params, ContentType.form)
}

// 关联机器人
export const relationRobots = (params:any) => {
  return https().request(`building/robots`, Method.POST, params, ContentType.form)
}

// 获取楼宇地图列表
export const getmaplists = (params: any) => {
	return https().request('building/floor/map', Method.GET, params, ContentType.form)
}

// 删除楼宇地图
export const deletemap = (params: any) => {
	return https().request(`building/floor/map`, Method.DELETE, params, ContentType.form)
}

// 获取楼宇关联机器人数量
export const buildingRobtCount = (params:any) => {
  return https().request('building/robot_count', Method.GET, params, ContentType.form)
}

// 获取所有楼宇和楼层
export const buildingAll = (params:any) => {
  return https().request('building/all', Method.GET, params, ContentType.form)
}

// 梯控绑定楼宇
export const bindingLadder = (building_id:any,elevators_id:any) => {
  return https().request(`/building/elevators?building_id=${building_id}&elevators=${elevators_id}`, Method.POST, building_id, ContentType.json)
}

// 梯控解绑楼宇
export const unbindingLadder = (elevators_id:any) => {
  return https().request(`/building/elevators?elevators=${elevators_id}`, Method.DELETE, elevators_id, ContentType.json)
}

// 梯控编辑可前往楼层
export const goToFloor = (params:any) => {
  return https().request(`/building/elevators/floors`, Method.PUT, params, ContentType.json)
}

// 门禁绑定楼层
export const bindingAccess = (door_id:any,floor_id:any) => {
  return https().request(`/door/bind?doorid=${door_id}&floorid=${floor_id}`, Method.PUT, floor_id, ContentType.json)
}

// 门禁解绑楼层
export const unbindingAccess = (door_id:any) => {
  return https().request(`/door/unbind?doorid=${door_id}`, Method.PUT, door_id, ContentType.json)
}

// 店铺查询
export const shopQuery = (params:any) => {
  return https().request('shop', Method.GET, params, ContentType.form)
}

// 店铺更新
export const shopUpdate = (params:any) => {
  return https().request('shop', Method.PUT, params, ContentType.json)
}

// 店铺添加
export const shopAdd = (params:any) => {
  return https().request('shop', Method.POST, params, ContentType.json)
}

// 店铺删除
export const shopDelete = (params:any) => {
  return https().request('shop', Method.DELETE, params, ContentType.form)
}

// 获取店铺地图列表
export const getshopmaplists = (params: any) => {
	return https().request('/shop/map', Method.GET, params, ContentType.form)
}

// 删除店铺地图
export const deleteshopmap = (params: any) => {
	return https().request('shop/map', Method.DELETE, params, ContentType.form)
}

// 店铺绑定、更换机器人
export const shopRobotUpdate = (params:any) => {
  return https().request(`/shop/robots`, Method.POST, params, ContentType.form)
}

// 机器人解绑楼栋
export const buildingRobotDelete = (params:any) => {
  return https().request(`/building/robots`, Method.DELETE, params, ContentType.form)
}

// 机器人解绑店铺
export const shopRobotDelete = (params:any) => {
  return https().request(`/shop/robots`, Method.DELETE, params, ContentType.form)
}


